import { createDrawerContext } from './drawer-context';
import { DrawerContent } from '@/components/drawer-navigation/drawer-content';
import { LAYOUT_SIZE_TO_DRAWER_WIDTH_MAP, LayoutSize } from './layout-context';
import { NavigationStateType } from '@/hooks/use-side-nav-press';

const {
  DrawerContext,
  DrawerContextProvider,
  useDrawerContext,
  useMaybeDrawerContext,
} = createDrawerContext<NavigationStateType>((layoutSize) => ({
  ContentComponent: DrawerContent,
  fixed: layoutSize === LayoutSize.LARGE,
  position: 'left',
  width: LAYOUT_SIZE_TO_DRAWER_WIDTH_MAP[layoutSize],
}));

export const NavigationDrawerContext = DrawerContext;
export const NavigationDrawerContextProvider = DrawerContextProvider;
export const useNavigationDrawerContext = useDrawerContext;
export const useMaybeNavigationDrawerContext = useMaybeDrawerContext;
